import React, { useRef, useContext } from "react";
import { filter, map, includes, sortBy } from 'lodash';
import { IndexData } from '../index-context';
import SvgIcon from "../../../../common/components/svg-icon";
import { MarkupData } from "../components/concept-tab-markup/markups-logic";
import NoData from './noData';
import Note from "./note";
import SummaryItem from "./summaryItem";

const Index = ({
  metric, summaryClassName,
  onGotSummary, answers
}) => {
  const { focusConcept } = useContext(MarkupData);
  const { aiSummaries, aiSummaryAvailable } = useContext(IndexData);

  const summariesRef = useRef(aiSummaries);
  summariesRef.current = aiSummaries;

  const summaries = filter(aiSummaries, (el) => (
    el.source_id === metric.source_id && el.source_type === metric.source_type && includes(el.tag, metric.tag)
  ));

  const regions = sortBy(focusConcept.regions, (item) => item.id);

  return (
    <>
      {
        aiSummaryAvailable &&
        <div className="summary-panel -multi comparisons_plate -bordered -dark -js-scorecard">
          <div>
            <SvgIcon name="scheme" />
          </div>
          {!regions.length &&
            <NoData
              text={ "There are no regions to create summary for." }
              noRegions
            />
          }
          {
            !!regions.length &&
            <div className="summary-list">
              <ul>
                {
                  map(regions, (item, i) => {
                    return (
                      <SummaryItem
                        key={ `optionsIndex${i}` }
                        title={ item.name }
                        region={ item }
                        tag={ `region_${item.id}` }
                        onGotSummary={ onGotSummary }
                        className={ summaryClassName }
                        metric={ metric }
                      />
                    );
                  })
                }
                { !!summaries.length && <Note count={ summaries.length } /> }
              </ul>
            </div>
          }
        </div>
      }
    </>
  );
};

export default Index;
